<template>
  <div>
    <p>
      You are impersonating <b class="wt-bold">{{ user.name }}</b> ({{ user.type }})
      <a @click.prevent="stop" class="interactive">Stop impersonating</a>.
    </p>
  </div>
</template>

<script>
export default {
  props: {
    token: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  mounted () {
    // Set token
    this.$store.commit('user/token', this.token)
    this.$store.dispatch('user/setAuthHeader')

    // Save our user details
    this.$store.commit('user/authenticated', this.user)
    axios.get('/sanctum/csrf-cookie').then(() => {
      this.$store.dispatch('user/refreshUser')
    })
  },
  methods: {
    stop() {
      this.$store.commit('user/deAuthenticated')
      window.location = '/impersonate/stop'
    }
  }
}
</script>
